// ======================================================================
// File Name       : livePerformance
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';

export function getLivePerformanceUserCount(
  data = {
    selectTargetData: 0,
    searchInfo: null,
  },
    ) {
  return commonCallApi({
    path: 'live/EachLiveUserCount',
    data,
  });
}

export function getOrganizerUserSecernId(
  data = {
    selectTargetData: 0,
    searchInfo: null,
  },
    ) {
  return commonCallApi({
    path: 'user/GetList',
    data,
  });
}

export function getRelationStatusList(
  data = {
    searchInfo: null,
  },
    ) {
  return commonCallApi({
    path: 'learningOperation/GetStatusLive',
    data,
  });
}
